module.exports = __webpack_public_path__ + "img/lucklotto.93cd5825.png";